"use client";
import { useSyncExternalStore } from "react";

// Module-level store for the contact modal's open state — deliberately NOT a
// React context. The trigger ("Send Message" CTA) lives in the Header subtree
// while <ContactModal /> is mounted in BaseLayout; context updates did not
// propagate reliably across this app's server-component + transition-router
// boundary. useSyncExternalStore is React's primitive for cross-tree state and
// cannot be reset by a remount.
let isOpen = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const openContactModal = () => {
  if (isOpen) return;
  isOpen = true;
  emit();
};

export const closeContactModal = () => {
  if (!isOpen) return;
  isOpen = false;
  emit();
};

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};

export const useContactModalOpen = () =>
  useSyncExternalStore(
    subscribe,
    () => isOpen,
    () => false
  );
